import { takeLatest } from 'redux-saga/effects';

import {
  GET_INSTRUMENT,
  GET_INSTRUMENT_DOCUMENTS,
  GET_INSTRUMENT_PRODUCTS,
  GET_INSTRUMENT_RATING_NEWS,
  GET_INSTRUMENT_RESEARCH,
  REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA,
  REQUEST_INSTRUMENT_RATING,
} from './instrumentActions';
import {
  fetchInstrumentSaga,
  fetchInstrumentDocumentsSaga,
  fetchInstrumentProductsSaga,
  fetchInstrumentRatingNewsSaga,
  fetchInstrumentResearchSaga,
  requestInstrumentRatingSaga,
  requestInstrumentRatingAndFetchData,
} from './instrumentSaga';

export function* instrumentWatchers() {
  yield takeLatest(GET_INSTRUMENT, fetchInstrumentSaga);
  yield takeLatest(GET_INSTRUMENT_DOCUMENTS, fetchInstrumentDocumentsSaga);
  yield takeLatest(GET_INSTRUMENT_PRODUCTS, fetchInstrumentProductsSaga);
  yield takeLatest(GET_INSTRUMENT_RATING_NEWS, fetchInstrumentRatingNewsSaga);
  yield takeLatest(GET_INSTRUMENT_RESEARCH, fetchInstrumentResearchSaga);
  yield takeLatest(REQUEST_INSTRUMENT_RATING, requestInstrumentRatingSaga);
  yield takeLatest(REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA, requestInstrumentRatingAndFetchData);
}
